module.exports = __webpack_public_path__ + "static/media/ruhtinas-crown+logo-blue-bg-gold-400x240.109f213b.png";